export default function NotFound() {
  return (
    <div className="text-xl font-semibold text-red-700">
      404 - Page Not Found
    </div>
  );
}
